import { BASE_BE_URL } from "../../lib/sessionClient";


export const IDLE_CYLINDERS  = BASE_BE_URL + "/cylinder/at-station-report"